import { createActionGroup, props } from '@ngrx/store';
import { NgRxActionProps } from 'src/app/core/state/models/ngrx-action-props.model';
import {
  FetchFeatureFlagProps,
  SetFailedFeatureFlagProps,
  SetFeatureFlagProps,
} from 'src/app/core/state/slices/feature-flag/feature-flag.model';

export const FeatureFlagActions = createActionGroup({
  source: 'FeatureFlagFeature',
  events: {
    'Set Feature Flags': props<NgRxActionProps<SetFeatureFlagProps>>(),
    'Set Failed Feature Flags': props<NgRxActionProps<SetFailedFeatureFlagProps>>(),
    'Fetch Feature Flags': props<NgRxActionProps<FetchFeatureFlagProps>>(),
    'Reset State': props<NgRxActionProps>(),
    'Init State': props<NgRxActionProps>(),
  },
});
